import { useEffect, useState } from "react";
import type { Session } from "@supabase/supabase-js";
import { theoDoiPhien } from "./api/auth";
import { LoginScreen } from "./screens/LoginScreen";
import { CongVao } from "./app/CongVao";
import "./ui/tokens.css";
import "./ui/ui.css";
import "./app/voApp.css";

export function App() {
  const [session, setSession] = useState<Session | null | undefined>(undefined);

  useEffect(() => theoDoiPhien(setSession), []);

  if (session === undefined) return null; // chờ Supabase trả phiên lần đầu, tránh nháy màn đăng nhập
  return session ? <CongVao userId={session.user.id} /> : <LoginScreen />;
}
